<div class="basket__appliance">
  <div class="basket__appliance-content">
    <div class="basket__appliance-header">
      <div class="basket__appliance-title">
        <app-icon [family]="'solid'" [name]="'circle-check'" [size]="'lg'" />
        <ng-content select="[slot=title]" />
      </div>
      <div class="basket__appliance-body">
        <ng-content select="[slot=body]" />
      </div>
    </div>

    @if (canRemoveAppliance()) {
      <button
        (click)="onApplianceRemove()"
        aria-label="Remove appliance"
        class="basket__appliance-remove"
        type="button"
      >
        <app-icon [name]="'trash-can'" [size]="'lg'" />
      </button>
    }
  </div>
</div>
